import { apiClient } from '../lib/apiClient';

export interface DailyMusterCount {
    date: string;
    musterRollCount: number;
    attendanceCount: number;
}

interface ApiDailyMusterCountByDistrictItem {
    musterDate: string;
    musterRollCount: number;
    stateId: number;
    districtId: number;
}

interface ApiDailyMusterCountByDistrictResponse {
    success: boolean;
    data: ApiDailyMusterCountByDistrictItem[];
    message: string;
}

export interface GetDailyMusterCountRequest {
    year: number;
    month: number;
    stateId: number;
    districtId: number;
}

export const musterCountService = {
    /**
     * Get daily muster roll counts for a specific year, month, state, and optionally district
     */
    async getDailyMusterCount(request: GetDailyMusterCountRequest): Promise<DailyMusterCount[]> {
        const params = new URLSearchParams();
        params.append('year', request.year.toString());
        params.append('month', request.month.toString());
        params.append('stateId', request.stateId.toString());
        params.append('districtId', request.districtId.toString());

        // Always use the daily-count-by-district endpoint
        const url = `api/muster-rolls/daily-count-by-district?${params.toString()}`;

        const response = await apiClient<ApiDailyMusterCountByDistrictResponse>(url, {
            method: 'GET',
        });

        // Map the API response to the expected format
        return response.data.map((item) => ({
            date: item.musterDate,
            musterRollCount: item.musterRollCount,
            attendanceCount: 0, // Not provided by this endpoint
        }));
    },
};
